import { render, staticRenderFns } from "./ChuFangList.vue?vue&type=template&id=510d58be&scoped=true"
import script from "./ChuFangList.vue?vue&type=script&lang=js"
export * from "./ChuFangList.vue?vue&type=script&lang=js"
import style0 from "./ChuFangList.vue?vue&type=style&index=0&id=510d58be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510d58be",
  null
  
)

export default component.exports